import { Link, useForm, usePage } from '@inertiajs/react'

interface Account { id: number; name: string; slug: string; logo_url?: string | null }
interface Props { account: Account }

export default function CatalogForgotPassword({ account }: Props) {
  const { data, setData, post, processing } = useForm({ email: '' })
  const { flash } = usePage().props as any

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/${account.slug}/portal/forgot_password`)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
        <Link href={`/${account.slug}/catalog`} className="flex items-center gap-2 font-bold text-lg mb-6 text-[#202020]">
          {account.logo_url && <img src={account.logo_url} className="h-8 w-8 object-contain bg-gray-100 rounded" />}
          {account.name}
        </Link>
        <h1 className="text-xl font-bold text-[#202020] mb-1">Enlace para tu cuenta</h1>
        <p className="text-sm text-gray-500 mb-4">
          Escribe el correo con el que hiciste tu pedido y te enviamos un enlace nuevo para crear tu contraseña.
        </p>

        {flash?.alert && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">{flash.alert}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <input type="email" placeholder="Email" value={data.email}
            onChange={(e) => setData('email', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
            required />
          <button type="submit" disabled={processing}
            className="w-full bg-[#FFC107] text-[#202020] py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
            {processing ? 'Enviando...' : 'Enviarme el enlace'}
          </button>
        </form>

        <p className="text-xs text-gray-500 mt-4 text-center">
          El enlace llega al correo y es válido por 10 días.
        </p>
        <p className="text-xs text-center mt-1">
          <Link href={`/${account.slug}/portal/login`} className="text-[#55ACEE] hover:underline">
            Volver a iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  )
}
